/** Fields for hours approval list rows (must include agreed OT so the badge can render). */
export const HOURS_APPROVAL_LIST_FIELDS = [
  "billing",
  "id",
  "date",
  "time",
  "approved",
  "not_approved",
  "processed",
  "status",
  "user",
  "project",
  "project_activity",
  "project_activity_id",
  "report",
  "work_order",
  "tripletex_entry_id",
  "last_synced_at",
  "updated_at",
  "tripletex_sync_ready",
  "tripletex_sync_block_reason",
  "tripletex_sync_block_reason_message",
  "agreed_overtime_requested",
  "agreed_overtime_hours",
  "agreed_overtime_confirmed",
  "agreed_overtime_note",
].join(",");

/** Extra fields fetched when an approval row is expanded. */
export const HOURS_APPROVAL_DETAIL_FIELDS = [
  "id",
  "description",
  "trips",
  "process_note",
  "agreed_overtime_requested",
  "agreed_overtime_hours",
  "agreed_overtime_confirmed",
  "agreed_overtime_note",
].join(",");
